import { render, staticRenderFns } from "./Informdetails.vue?vue&type=template&id=2c5aec00&scoped=true&"
import script from "./Informdetails.vue?vue&type=script&lang=js&"
export * from "./Informdetails.vue?vue&type=script&lang=js&"
import style0 from "./Informdetails.vue?vue&type=style&index=0&id=2c5aec00&scoped=true&lang=css&"
import style1 from "./Informdetails.vue?vue&type=style&index=1&id=2c5aec00&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5aec00",
  null
  
)

export default component.exports